import ActionRequired from './ActionRequired';
import Cancelled from './Cancelled';
import Declined from './Declined';
import Deposit from './Deposit';
import Finished from './Finished';
import JobStatus from './JobStatus';
import Loading from './Loading';
import PaidByBank from './PaidByBank';
import PaidByCard from './PaidByCard';
import ReadyToStart from './ReadyToStart';
import Referred from './Referred';
import SatNote from './SatNote';
import SatNoteDelayed from './SatNoteDelayed';
import UnderReview from './UnderReview';

const Generic = {
  ActionRequired,
  Cancelled,
  Declined,
  Deposit,
  Finished,
  JobStatus,
  Loading,
  PaidByCard,
  PaidByBank,
  ReadyToStart,
  Referred,
  SatNote,
  SatNoteDelayed,
  UnderReview,
};

export default Generic;
